import React, { useMemo } from "react";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import UniversalTableDatasetButtonComponent from "./UniversalTableDatasetButtonComponent";
import { IUniversalDatasetTableRow } from "./universal-dataset-table-editor/CellValuesEditor";

interface DatasetButtonProps {
  dataset: DatasetDataInfoResponse;
  columnIndex: number;
  rowData: IUniversalDatasetTableRow;
  compactMode?: boolean;
}

const DatasetButton = ({ dataset, columnIndex, rowData, compactMode }: DatasetButtonProps) => {
  const datasetData = dataset?.data?.length ? dataset.data[0] : null;
  const datasetDecimalPlaces = useMemo(() => dataset?.decimalPlaces ?? 2, [dataset]);
  const datasetTime = useMemo(
    () => (datasetData?.key ? new Date(datasetData.key as string) : null),
    [datasetData]
  );
  const datasetId = useMemo(
    () =>
      dataset
        ? `dataset-label-${dataset.identifier.split(":")[1]}-${dataset.identifier.split(":")[0]}`
        : null,
    [dataset]
  );

  let value: string | undefined;
  if (datasetData) {
    value = datasetData.value.toFixed(datasetDecimalPlaces);
  }

  return (
    <UniversalTableDatasetButtonComponent
      id={datasetId ?? ""}
      columnIndex={columnIndex}
      rowData={rowData}
      value={value}
      compactMode={compactMode}
      dataset={dataset!}
      data={datasetData}
      time={datasetTime!}
    />
  );
};

export default DatasetButton;
